import { Outlet } from "react-router-dom";

import logo from "@/assets/applogo.svg";

export const PublicLayout = () => (
    <div className="relative flex min-h-screen items-center justify-center bg-slate-950 px-4 py-10 sm:px-6 lg:px-12">
        <div className="relative z-10 w-full max-w-6xl overflow-hidden rounded-[2.75rem] border border-white/10 bg-slate-950/70 shadow-2xl backdrop-blur-xl">
            <div className="grid min-h-[720px] grid-cols-1 lg:grid-cols-[2fr_3fr]">
                <aside className="relative hidden overflow-hidden lg:flex">
                    <div className="flex w-full flex-col">
                        <div className="flex basis-[30%] min-h-[220px] flex-col justify-between bg-white px-10 py-12 text-primary-700 shadow-2xl shadow-primary-900/15">
                            <div className="flex items-center gap-3">
                                <img src={logo} alt="RideToFive" className="h-12 w-auto" />
                                <div>
                                    <p className="font-display text-xl font-semibold leading-tight text-primary-700">
                                        RideToFive
                                    </p>
                                    <p className="text-sm font-medium uppercase tracking-[0.45em] text-primary-400">
                                        Control Center
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="relative flex flex-1 overflow-hidden bg-gradient-to-br from-primary-600 via-primary-500 to-primary-700">
                            <div className="pointer-events-none absolute -left-16 top-[-10%] h-60 w-60 rounded-full bg-white/10 blur-2xl" />
                            <div className="pointer-events-none absolute right-[-20%] top-[35%] h-72 w-72 rotate-12 rounded-[4rem] bg-white/10 blur-3xl" />
                            <div className="pointer-events-none absolute inset-0">
                                <div className="absolute inset-0 grid grid-cols-4 gap-6 px-10 py-10">
                                    {[...Array(20)].map((_, index) => (
                                        <div key={index} className="relative">
                                            <img
                                                src={logo}
                                                alt=""
                                                aria-hidden="true"
                                                className="absolute left-1/2 top-1/2 h-12 w-auto -translate-x-1/2 -translate-y-1/2 opacity-[0.08]"
                                                style={{
                                                    transform: `translate(-50%, -50%) rotate(${(index % 5) * 8 - 12}deg) scale(${0.85 + (index % 4) * 0.07})`
                                                }}
                                            />
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </aside>

                <section className="relative flex items-center justify-center bg-slate-100 px-6 py-12 dark:bg-slate-900 sm:px-10 lg:px-16">
                    <div className="absolute inset-0 bg-gradient-to-br from-white via-white/60 to-white/40 dark:from-slate-900 dark:via-slate-900/80 dark:to-slate-900/60" />
                    <div className="relative z-10 w-full max-w-md">
                        <Outlet />
                    </div>
                </section>
            </div>
        </div>
        <div className="pointer-events-none absolute inset-x-0 top-[10%] z-0 h-[420px] bg-primary-600/20 blur-3xl" />
    </div>
);

